var map = {
	"pages/App.tsx": [
		3941
	],
	"pages/CuonGiaPha.tsx": [
		5737,
		426,
		991,
		737
	],
	"pages/GiaPha.tsx": [
		651,
		426,
		442
	],
	"pages/Other.tsx": [
		2807
	],
	"pages/PageGiaPha.tsx": [
		1598,
		426,
		991,
		598
	],
	"pages/ToGiaPha.tsx": [
		4055,
		991,
		55
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2947;
module.exports = webpackAsyncContext;